import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Invest = () => {
  return (
    <section className="relative flex flex-col w-full h-full md:flex-row items-start justify-between py-28 md:py-40 px-4 md:px-24 overflow-hidden text-white">
      <div className="container flex flex-col md:flex-row mx-auto md:pl-6 w-full">
        <div className="w-full md:max-w-lg space-y-8 pt-5 md:pt-10">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-sm md:text-base font-orbitron tracking-[0.3em] uppercase text-white/80"
          >
            Atheriam
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-bold font-orbitron leading-tight"
          >
            $ATH ICO
            <br />
            <span className="text-white">Coming Soon</span>
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="bg-white/5 backdrop-blur-sm p-6 md:p-8 rounded-xl border border-orange-500/40 shadow-lg w-full"
          >
            <p className="text-white/80 text-sm font-bold uppercase tracking-widest mb-3">
              Announcement Soon
            </p>
            <p className="text-2xl md:text-3xl font-semibold text-white font-orbitron mb-3">
              The drop is loading…
            </p>
            <p className="text-gray-300 text-base md:text-lg leading-relaxed">
              Sale details, rates, and allocation for{" "}
              <span className="text-white font-bold">$ATH</span> are being
              finalized. Stay close - the official ICO announcement lands here
              first.
            </p>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-gray-200 text-lg"
          >
            Until then, explore how $ATH powers play, staking, and rewards
            across Atheriam.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-wrap gap-3"
          >
            <Link
              to="/tokenomics"
              className="inline-block no-underline px-8 py-3 text-lg font-bold text-white bg-orange-500 hover:bg-white hover:text-black rounded-full transition-all duration-300"
            >
              View Tokenomics
            </Link>
            <Link
              to="/whitepaper"
              className="inline-block no-underline px-8 py-3 text-lg font-bold text-white border-2 border-orange-500 hover:bg-orange-500 hover:text-white rounded-full transition-all duration-300"
            >
              Read Whitepaper
            </Link>
          </motion.div>
        </div>

        <div className="relative w-full flex justify-end items-start md:items-center mt-20 md:mt-0">
          <motion.img
            src="/assets/ROULETTE2.gif"
            alt="Roulette"
            className="w-full lg:w-2/3 md:w-auto rotate-[8deg]"
          />

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35, duration: 0.55, type: "spring" }}
            className="ico-fun-chip ico-fun-chip--drop"
          >
            <span className="ico-fun-chip__suit" aria-hidden>
              ♠
            </span>
            <span className="ico-fun-chip__label">Next drop</span>
            <span className="ico-fun-chip__value">TBA</span>
            <span className="ico-fun-chip__tag">Hot seat</span>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.55, type: "spring" }}
            className="ico-fun-chip ico-fun-chip--access"
          >
            <span className="ico-fun-chip__suit" aria-hidden>
              ♦
            </span>
            <span className="ico-fun-chip__label">Access list</span>
            <span className="ico-fun-chip__value">VIP Queue</span>
            <span className="ico-fun-chip__tag">Opening soon</span>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.65, duration: 0.55, type: "spring" }}
            className="ico-fun-chip ico-fun-chip--sale"
          >
            <span className="ico-fun-chip__suit" aria-hidden>
              ♥
            </span>
            <span className="ico-fun-chip__label">$ATH vault</span>
            <span className="ico-fun-chip__value">Sealed</span>
            <span className="ico-fun-chip__tag">Jackpot loading</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Invest;
